import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TableColumn } from 'src/@vex/interfaces/table-column.interface';
import Swal from 'sweetalert2';
import { TransactionsInternalServicesService } from '../../../../../../../src/app/shared/services/transactions-internal-services.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserService } from 'src/app/shared/services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { UntypedFormControl } from '@angular/forms';
import { User } from 'src/core/interfaces/user';
import { Permissions } from 'src/assets/static-data/permissions';
import { SalesOrderStatus } from 'src/assets/static-data/enums/sales-order-status.enum';
import { ISalesOrder } from 'src/core/interfaces/SalesOrder';
import { SalesOrderService } from 'src/app/shared/services/sales-order.service';
import { stat } from 'fs';
import { Subject, takeUntil } from 'rxjs';


@UntilDestroy()
@Component({
  selector: 'app-sales-order',
  providers: [DatePipe], // Provide DatePipe
  templateUrl: './sales-order.component.html',
  styleUrls: ['./sales-order.component.scss','../transactions.component.scss']
})
export class SalesOrderComponent {

  SalesOrderStatus = SalesOrderStatus; // Expose the enum to the template
  SalesOrder: ISalesOrder[];
  permissions = new Permissions();
  currentUser: User;
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
  //canAssignDrivers: boolean;
  isLoading = false
  isInactiveLoading = false;
  clicked = false;
  lastSyncDate:Date;
  filteredDataStatus:number=-1;
  currentPage = 0;
  //activeCount = 0;
  filteredDataSearch:string=null;
  isRtl:boolean;
  typingTimer: any;
  doneTypingInterval = 800; // Delay in ms

  columns: TableColumn<ISalesOrder>[] = [
    { label: this.translateService.instant("TRANSACTIONUMBER.TEXT"), property: 'transactionNumber', type: 'text', visible: true },
    { label: this.translateService.instant("TRANSACTIONDATE.TEXT"), property: 'transactionDate', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERCODE.TEXT"), property: 'customerCode', type: 'text', visible: true },
    { label: this.translateService.instant("CUSTOMERNAME.TEXT"), property: 'customerName', type: 'text', visible: true },
    { label: this.translateService.instant("STATUS.TEXT"), property: 'status',type:'text', visible: true },
    { label: this.translateService.instant("ACTIONS.TEXT"), property: 'actions', type: 'button', visible: true },
  ];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500,1000,5000,10000];
  dataSource: MatTableDataSource<ISalesOrder> | null;
  totalRows = 0;

  //selection = new SelectionModel<IVehicle>(true, []);
  searchCtrl = new UntypedFormControl();
  private destroy$ = new Subject<void>();

  //labels = aioTableLabels;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private dialog: MatDialog,
    private userService: UserService,
    private authService: AuthService, private translateService: TranslateService,
    private salesOrderService: SalesOrderService,
    private router: Router,    private datePipe: DatePipe,
    private salesOrderInternalService:TransactionsInternalServicesService
  ) {
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }


  ngOnInit() {
    // debugger
    this.dataSource = new MatTableDataSource();

    this.getSalesOrders();
    this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur'?true:false;


    this.currentUser = this.authService.currentUserValue;

    this.userService.checkPermission(this.currentUser?.id, this.permissions.CREATE_SALES_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.canAdd = response.data;
    })
    this.userService.checkPermission(this.currentUser?.id, this.permissions.UPDATE_SALES_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      // debugger
      this.canEdit = response.data;
    })
    this.userService.checkPermission(this.currentUser?.id, this.permissions.DELETE_SALES_ORDER).pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.canDelete = response.data;
    })
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnDestroy() {
    // Emit destroy signal to unsubscribe all
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSalesOrders(criteria = null){
    this.isLoading =true;
    this.salesOrderService.getPaginatedSalesOrders(this.currentPage, this.pageSize, true, criteria).subscribe(response => {
      // // debugger;
      this.isLoading = false;
      this.dataSource.data = response.data.items;
      this.dataSource.data.forEach((row) => {
     
      row.status=this.salesOrderInternalService.getStatusKeyFromValue(row.status,1) as SalesOrderStatus;

        row.transactionDate = this.datePipe.transform(row.transactionDate, 'dd/MM/yyyy');
      });

      //this.activeCount = response.data.items.length;
      setTimeout(() => {
        this.paginator.pageIndex = this.currentPage;
        this.paginator.length = response.data.count;
      });
      console.log(response.data.items);
    });
  }

  viewRow(order:any){
    this.router.navigate(['/transactions/sales-orders/view', order.id]);
  }

  pageChanged(event: PageEvent) {
    
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getSalesOrders();
  }

  createSalesOrder() 
  {
    this.router.navigate(['/transactions/sales-orders/create']);

  }

  updateSalesOrder(order: any) {
    this.router.navigate(['/transactions/sales-orders/edit', order.id]);
  
  }

  deleteSalesOrder(order: any) {
    // if(vehicles.some(vehicle => vehicle.isActive) == true)
    //   {
    //     Swal.fire(this.translateService.instant("CANT_DELETE_ACTIVE_ITEM.TEXT"),"", 'warning');
    //     return; 
    //   }

    Swal.fire({
      title: this.translateService.instant("ARE_YOU_SURE.TEXT"),
      text: this.translateService.instant("YOU_WONT_BE_ABLE_TO_REVERT_THIS.TEXT"),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
      cancelButtonText: this.translateService.instant("CANCEL.TEXT"),
      confirmButtonText: this.translateService.instant("YES_DELETE_IT.TEXT")
    }).then(result => {
      if (result.value) {
        this.salesOrderService.deleteSalesOrder(order.id).subscribe(response => {
          if(response.statusCode === 200){
            Swal.fire(this.translateService.instant("Sales-order_DELETED_SUCCESSFULLY.TEXT"),"", 'success');
            this.getSalesOrders();
          } else {
            Swal.fire(this.translateService.instant("SOMETHING_WENT_WRONG.TEXT"), this.translateService.instant("PLEASE_CONTACT_ADMIN.TEXT"), 'error')
          }
        })
        //vehicles.forEach(vehicle => this.selection.deselect(vehicle));
      }
    }); 
  }



  onTypingFinished(value: string) {
    console.log('Finished typing:', value);
    this.onFilterChange(value)
    // Your search/filter logic here
  }

  onKeyup(event: any) {
    // Clear the timer on every keyup to reset the delay
    clearTimeout(this.typingTimer);
    
    // Set the timer to trigger after `doneTypingInterval` ms
    this.typingTimer = setTimeout(() => {
      this.onTypingFinished(event.target.value);
    }, this.doneTypingInterval);
  }

  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    this.currentPage=0;
    value = value.trim();
    value = value.toLowerCase();
    this.getSalesOrders(value);
    //this.dataSource.filter = value;
  }

  toggleColumnVisibility(column, event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }


  getStatusClasses(status: string):{ textClass: string; bgClass: string } | undefined{

      return this.salesOrderInternalService.getStatusClasses(status, 1);


  }
  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    //const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    //return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    //this.isAllSelected() ?
      //this.selection.clear() :
      //this.dataSource.data.forEach(row => this.selection.select(row));
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  loadData(criteria = null,status) {
    //this.isLoading = true;
    this.filteredDataStatus=status;
   
  }

}
